import { useQuery } from '@tanstack/react-query'

import { request } from 'Lib/axios'
import { ExtractFnReturnType } from 'Lib/react-query'
import { useUserStore } from 'Stores/userStoreModuleFed'
type GetAccountVisitCountResp = {
  count: number
}

const getAccountVisitCountForPM = (accountId: number, userId: number, period = 90) =>
  request<GetAccountVisitCountResp>({
    url: `/users/${userId}/accounts/${accountId}/dashboard/visit-count?period=${period}`,
    method: 'GET',
  })

type QueryFnType = typeof getAccountVisitCountForPM

export const useAccountVisitCount = () => {
  const { accountId, userId, subscriptionId } = useUserStore()
  const query = useQuery<ExtractFnReturnType<QueryFnType>>({
    queryFn: () => getAccountVisitCountForPM(accountId, userId),
    queryKey: ['getAccountStatusPM', accountId],
    enabled: !!accountId && !!subscriptionId,
    refetchInterval: false,
  })

  const { data } = query
  const result = Boolean(!data || data instanceof Error ? false : Number(data.count) > 0 || false)

  return { ...query, data: result }
}
